export const devicesContent = {
  hero: {
    title: "Supported Devices",
    subtitle: "FamilyCast works with affordable tablets and devices you may already own. Turn any tablet into your family command center."
  },
  deviceOptions: [
    {
      name: 'Amazon Fire Tablets',
      iconName: 'Tablet',
      priceRange: '$80-150',
      priceNumeric: 80,
      bestFor: 'Budget-friendly family displays',
      specs: [
        'Fire HD 8 / HD 10 / Fire 7 / Max 11',
        '7-11 inch displays',
        '2GB+ RAM recommended',
        'WiFi connectivity',
        'Built-in kiosk mode support'
      ],
      setupDifficulty: 'Easy',
      setupTime: '15-20 minutes',
      docsLink: 'https://docs.familycast.app/hardware/fire-tablet-setup',
      availability: 'Available'
    },
    {
      name: 'Apple iPads',
      iconName: 'Tablet',
      priceRange: '$250-800',
      priceNumeric: 250,
      bestFor: 'Premium family command centers',
      specs: [
        'iPad 5th gen+ (2017+)',
        'iPad Air 3rd gen+ (2019+)',
        'iPad Pro (all models)',
        'iPad mini 5th gen+ (2019+)',
        'iOS 14.0+ required',
        'Guided Access kiosk mode'
      ],
      setupDifficulty: 'Easy',
      setupTime: '10-15 minutes',
      docsLink: 'https://help.familycast.app/hardware/ipad-setup',
      availability: 'Available'
    },
    {
      name: 'Android Tablets',
      iconName: 'PhoneAndroid',
      priceRange: '$100-400',
      priceNumeric: 100,
      bestFor: 'Flexibility across brands and budgets',
      specs: [
        'Android 9.0+ required',
        '2GB+ RAM, 16GB+ storage',
        'Samsung Galaxy Tab series',
        'Lenovo Tab series',
        'Google Pixel Tablet',
        'Requires Fully Kiosk Browser'
      ],
      setupDifficulty: 'Intermediate',
      setupTime: '20-30 minutes',
      docsLink: 'https://help.familycast.app/hardware/android-tablet-setup',
      availability: 'Available'
    },
    {
      name: 'Raspberry Pi (BYOD)',
      iconName: 'Computer',
      priceRange: '$35-75 + accessories',
      priceNumeric: 35,
      bestFor: 'Tech-savvy families with existing Pi hardware',
      specs: [
        'Raspberry Pi 4 (2GB+ RAM)',
        'Raspberry Pi 5 (4GB/8GB)',
        'Custom FamilyCast OS image',
        'Requires microSD card (16GB+)',
        'HDMI display support',
        'WiFi/Ethernet connectivity'
      ],
      setupDifficulty: 'Advanced',
      setupTime: '30-45 minutes',
      docsLink: 'https://help.familycast.app/hardware/raspberry-pi-byod-setup',
      availability: 'Available'
    },
    {
      name: 'Desktop/Laptop Computers',
      iconName: 'Computer',
      priceRange: 'Use existing devices',
      priceNumeric: 0,
      bestFor: 'Repurposing computers you already have',
      specs: [
        'Windows 10+ or macOS 10.15+',
        '4GB+ RAM recommended',
        'Modern web browser',
        'Stable internet connection',
        'Chrome, Firefox, Edge, Safari supported'
      ],
      setupDifficulty: 'Easy',
      setupTime: '5-10 minutes',
      docsLink: 'https://help.familycast.app/hardware/computer-setup',
      availability: 'Coming Soon'
    }
  ],
  comparison: {
    title: "Device Comparison",
    subtitle: "Choose the best device for your home and budget",
    columns: ["Device Type", "Price Range", "Setup Time", "Difficulty", "Status", "Setup Guide"]
  },
  details: {
    title: "Device Details",
    labels: {
      bestFor: "Best For",
      specs: "Specifications",
      setupTime: "Setup Time",
      setupGuide: "Setup Guide",
      comingSoon: "Coming Soon"
    }
  },
  byodVsKits: {
    title: "BYOD vs. Complete Kits",
    subtitle: "Choose your preferred setup method",
    byod: {
      title: "Bring Your Own Device (BYOD)",
      description: "Purchase hardware yourself and follow our simple setup guides. Maximum flexibility and affordability.",
      advantages: [
        { title: "Most affordable:", text: "Save money by using devices you choose" },
        { title: "Your choice:", text: "Pick any compatible device and brand" },
        { title: "Use what you have:", text: "Repurpose tablets you already own" },
        { title: "Easy to buy:", text: "Available from Amazon, Best Buy, or local stores" }
      ],
      considerations: [
        "Setup time: 10-45 minutes per device depending on type",
        "You handle hardware warranty and support",
        "Requires basic tech comfort (we provide guides!)"
      ],
      cta: "Get Started with BYOD"
    },
    kits: {
      title: "Complete Kits (Coming Soon)",
      description: "Pre-configured family displays shipped ready to plug in. Hardware warranty and support included.",
      advantages: [
        { title: "Plug-and-play:", text: "5 minute setup vs. 45 minutes" },
        { title: "Warranty included:", text: "Hardware support and replacement coverage" },
        { title: "Pre-configured:", text: "Tested and optimized for FamilyCast" },
        { title: "Perfect gift:", text: "Great for family members or friends" }
      ],
      considerations: [
        "Higher upfront cost vs. BYOD",
        "Limited device selection (curated options)",
        "Currently not available (launching Q2 2025)"
      ],
      cta: "Coming Q2 2025"
    }
  },
  recommendations: {
    title: "Which Device Should I Choose?",
    items: [
      {
        title: "Best Value",
        device: "Fire Tablets",
        description: "Starting at just $80, Fire Tablets are perfect for budget-conscious families. Great for kitchen counters, entryways, and command centers.",
        iconName: "AttachMoney"
      },
      {
        title: "Easiest Setup",
        device: "iPads",
        description: "10-15 minute setup with built-in Guided Access kiosk mode. Premium build quality ideal for living spaces and family rooms.",
        iconName: "Speed"
      },
      {
        title: "Most Flexible",
        device: "Android Tablets",
        description: "Wide range of brands, sizes, and price points. Choose Samsung, Lenovo, Google Pixel, or others to match your home and budget.",
        iconName: "Storage"
      }
    ]
  },
  cta: {
    title: "Ready to Get Started?",
    subtitle: "Choose your device and follow our step-by-step setup guides",
    buttons: {
      beta: "Join Beta Program",
      support: "Contact Support"
    }
  }
};
